import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);


const vuexPersist = new VuexPersist({
    key: 'App',
    storage: sessionStorage
  })


export const store = new Vuex.Store({
    plugins: [vuexPersist.plugin],
    state:{
        storeEmail:'',
        storeUid:'',
        storeUserName:''

    },

    getters: {
        getEmailUser: state => {
            return state.storeEmail
          },
          getUid: state => {
            return state.storeUid
          },
          getUname: state => {
            return state.storeUserName
          }
        },
    mutations:{
            SENDUSEREMAIL: (state, valoreMail) => {
              // mutate state
              try {
                state.storeEmail=valoreMail
                //alert('emil settata');
            }
                catch(err) {
                    console.log('errore in store ' + err.message);
                }
            },
            SENDUSERID: (state, valoreUserid) => {
                // mutate state
                try {
                  state.storeUid=valoreUserid
                  //alert('emil settata');
              }
                  catch(err) {
                      console.log('errore in store ' + err.message);
                  }
              },
              SENDUSERNAME: (state, valoreUserName) => {
                // mutate state
                try {
                  state.storeUserName=valoreUserName
                  //alert('emil settata');
              }
                  catch(err) {
                      console.log('errore in store ' + err.message);
                  }
              }

            



    }

})








// WEBPACK FOOTER //
// ./src/store.js